import * as React from "react";

const SwatchMobile: React.FC = () => {
    return (
        <svg width="60" height="60" viewBox="0 0 60 60" fill="none" xmlns="http://www.w3.org/2000/svg">
        <mask id="path-1-inside-1" fill="white">
        <rect x="14.25" y="13.5" width="31.5" height="31.5" rx="1"/>
        </mask>
        <rect x="14.25" y="13.5" width="31.5" height="31.5" rx="1" stroke="white" strokeWidth="3" strokeLinejoin="round" mask="url(#path-1-inside-1)"/>
        </svg>
    );
};

export default React.memo(SwatchMobile);
